export default "__VITE_ASSET__Bdw4xYlD__"